import { MapperBase } from '../../utilities/mapper-base';
import { ReviewSet } from '../ui/review-set.model';
import { ReviewSetResource } from '../resource/review-set.resource';

export class ReviewSetToReviewSetResourceMapper extends MapperBase<ReviewSet, ReviewSetResource> {
	map(source: ReviewSet): ReviewSetResource {
		const dest = {} as ReviewSetResource;
		dest.title = source?.name ?? '';
		dest.reviewSetId = source?.id;
		dest.caseId = source?.caseId;
		dest.status = source?.status;
		dest.reviewOrder = source?.reviewOrder;

		return dest;
	}

}
